export class Modal {
  constructor(name) {
    this.modal = document.querySelector('.modal');
    if (!this.modal) {
      const newModal = document.createElement('div');
      newModal.classList.add('modal');
      newModal.innerHTML = ''
                +'<a href="#" class="modal_cb modalAction" data-modalaction="modal-close"><span></span></a>'
                +'<div class="modal_body_wrap">'
                    +'<div class="modal_body">'
                        +'<div class="modal_content">'
                        +'</div>'
                    +'</div>'
                +'</div>'; 
      document.body.appendChild(newModal);

      const scrollTop = document.createElement('div');
      scrollTop.classList.add('scrollTop');
      document.body.appendChild(scrollTop);

      this.modal = newModal;
    }
    this.name = name;
    this.modal = document.querySelector('.modal');
    this.modalContent = document.querySelector('.modal_content');
    this.hasScrollbar = document.body.scrollHeight > window.innerHeight;

  }

  empty() {
    this.modalContent.innerHTML = '';
    document.querySelector('.modal_content').innerHTML = '';;
    // this.modalContent.classList.remove('modal_bg');
  }

  close() {

    this.modal.style.opacity = 0;
    if (document.body.classList.contains('fixed')) {
      document.body.classList.remove('fixed');
    }

    setTimeout(() => {
      this.modal.removeAttribute('style');
      this.modal.classList.remove('active');
      this.empty();
    }, 500);

  }

  active() {
    this.modal.classList.add('active');
    if (this.hasScrollbar) {
      document.body.classList.add('fixed');
      // modal.classList.add('fixed');
    }
    
  }


  data(title, data, buttons, images) {

    this.modalContent.innerHTML = `<div class="modal_content_data">${data}</div>`;

    var res = '';
    
    if (images) {   
      Object.values(images).forEach(function(e) {
        res += '<div class="carousel__slide">'
                    +'<img src="' + e.url + '"/>'
                    +'<p>' + e.name + '</p>'
                    +'</div>';
    
      });
      let modalCarousel = document.createElement('div');
      modalCarousel.classList.add('modal_carousel');
      modalCarousel.innerHTML = res;
      this.modalContent.prepend(modalCarousel);
    }

    if (buttons) {
      let res = '<div class="modal_buttons_inside">';
      buttons.forEach(function(button) {
        res += '<button'
                    + (button.class ? ` class="${button.class}"` : '')
                    + (button.type ? ` type="${button.type}"` : '')
                    + (button.modalaction ? ` data-modalaction="${button.modalaction}"` : '')
                    + (button.action ? ` data-action="${button.action}"` :'')
                    + ('>')
                    + (button.title ? button.title : '')
                    +'</button>';
      });
      res += '</div>';
        
      let modalButtons = document.createElement('div');
      modalButtons.classList.add('modal_buttons');
      modalButtons.innerHTML = res;
      this.modalContent.append(modalButtons);
    }

    if (title) {
      let modalTitle = document.createElement('div');
      modalTitle.classList.add('modal_title');
      modalTitle.innerHTML = title;
      this.modalContent.prepend(modalTitle);
    }
  }
}

const modal = new Modal();

document.addEventListener('click', function(e) {
  if (e.target.getAttribute('data-modalaction') === 'modal-close') {
    e.preventDefault();
    modal.close();
  }
});

document.onkeydown = function(evt) {
  evt = evt || window.event;
  if (evt.keyCode === 27&& modal.modal.classList.contains('active')) {
    modal.close();
  }
};
